import axios from "axios";
import {
    IIDDataSetFilter,
    ICrewMember,
    IIDDataSet,
    IEcdbIdentityResponse,
} from "../models/crewMember";

export const getQueryIDDataSets = async (filter: IIDDataSetFilter, searchByCid: boolean) => {
    const params = new URLSearchParams({ searchByCid: searchByCid + "" });
    Object.entries(filter).forEach(x => params.append(x[0], x[1]));
    const res = await axios.get("/api/crewMembers/query", { params: params });
    return res.data as IIDDataSet[];
};

export const sendCrewIdentityRequestToECDB = async (
    filter: IIDDataSetFilter,
    searchByCid: boolean
) => {
    const params = new URLSearchParams({ searchByCid: searchByCid + "" });
    Object.entries(filter).forEach(x => params.append(x[0], x[1]));
    const res = await axios.post("/api/crewMembers/query/ecdb", null, { params: params });
    return res.data as { identityRequestId: string; detailRequestId: string };
};

export const getCrewIdentityResponses = async (requestId: string, current: string[]) => {
    const res = await axios.get("/api/crewMembers/query/ecdb/" + requestId, {
        params: { current: current },
    });
    return res.data as IEcdbIdentityResponse;
};

export const getCrewMemberByGuid = async (guid: string) => {
    const res = await axios.get("/api/crewMembers/" + guid);
    return res.data as ICrewMember;
};

export const getCrewMemberByCid = async (cid: string) => {
    const res = await axios.get("/api/crewMembers/cid/" + cid);
    if (res.data) return res.data as ICrewMember;
    else return null;
};

export const createCrewMember = async (dto: IIDDataSet, image: File | undefined, copy: boolean) => {
    const formData = new FormData();
    formData.append("dto", JSON.stringify(dto));
    image && formData.append("image", image, image.name);
    return axios.post("/api/crewMembers", formData, { params: { copy } });
};

export const connectCrewMemberWithECDB = async (guid: string) => {
    return axios.post("/api/crewMembers/" + guid);
};

export const editCrewMember = async (dto: IIDDataSet, image: File | undefined) => {
    const formData = new FormData();
    formData.append("dto", JSON.stringify(dto));
    image && formData.append("image", image, image.name);
    return axios.patch("/api/crewMembers/" + dto.crewMemberGuid, formData);
};

export const deleteCrewMember = async (guid: string) => {
    return axios.delete("/api/crewMembers/" + guid);
};

export const sendCrewDetailRequestToECDB = async (cid: string) => {
    const res = await axios.post("/api/crewMembers/detail/ecdb", null, { params: { cid } });
    return res.data as string;
};

export const getCrewDetailResponseFromECDB = async (requestId: string) => {
    const res = await axios.get("/api/crewMembers/detail/ecdb/" + requestId);
    if (res.status === 200) return res.data as ICrewMember;
    else return null;
};

export const getCrewMembersWithoutCid = async () => {
    const res = await axios.get("/api/crewMembers/local");
    return res.data as IIDDataSet[];
};

export const connectWithLocalCrewMember = async (dto: IIDDataSet) => {
    const res = await axios.patch("/api/crewMembers/" + dto.crewMemberGuid + "/local", dto);
    return res.data as string;
};
